import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

export default function termsMenuSelect({ dateRange, setDateRange }) {
  const termsMenu = [
    {
      image: "",
      name: "1D",
    },
    {
      image: "",
      name: "1W",
    },
    {
      image: "",
      name: "1M",
    },
    {
      image: "",
      name: "YTD",
    },
    {
      image: "",
      name: "1Y",
    },
    {
      image: "",
      name: "All",
    },
  ];

  return (
    <FormControl
      variant="standard"
      sx={{ m: 1, minWidth: 60 }}
      className="termsMenuSelect vaultStatusMenu extraSmall"
    >
      <InputLabel id="termsMenuLabel">Period</InputLabel>
      <Select
        labelId="termsMenuLabel"
        id="termsMenu"
        value={dateRange}
        onChange={(e) => setDateRange(e.target.value)}
        label="Period"
      >
        {termsMenu.map((item) => {
          return (
            <MenuItem value={item.name} key={item.name}>
              {item.name}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}
